import {Component, Input, OnChanges, SimpleChanges, TemplateRef} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {ColDef, GridOptions} from 'ag-grid-community';
import {AgGridTableWrapper} from '../../utils';
import {ColAction, ListData} from '@pt/pt-models';
import { PermissionManager } from '@pt/pt-core';

@Component({
  template: `
    <ag-grid-angular
      *ngIf='gridOptions()'
      [statusBar]="statusBar"
      (filterChanged)="onFilterChanged()"
      class='ag-theme-balham w-100'
      [loadingOverlayComponent]="loadingOverlayComponent"
      [loadingOverlayComponentParams]="loadingOverlayComponentParams"
      [gridOptions]='gridOptions()'
      [suppressRowClickSelection]='true'
      (cellClicked)='cellClicked($event)'
      (columnMoved)='onMoveColumns($event)'
      (columnVisible)='onChangeColumnsVisible($event?.columns)'>
    </ag-grid-angular>
  `,
  selector: 'pt-details-table'
})
export class DetailsTableComponent extends AgGridTableWrapper<unknown> implements OnChanges {
  @Input() data: ListData<unknown> = null;
  @Input() columnDefinition: ColDef[];

  constructor(public translate: TranslateService, public permissionManager: PermissionManager) {
    super(translate, permissionManager);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.data) {
      this.onChangeData(changes.data.currentValue);
    }
  }

  loadData(): ListData<unknown> {
    return this.data;
  }

  createColumnDefs(): ColDef[] {
    return this.columnDefinition;
  }

  createGridOptions(columnDefs: ColDef[], rowData: unknown[]): GridOptions {
    return this.defaultGridOptions('DPG', columnDefs, rowData); //todo @nicola use ad-hoc gridOptions
  }

  clickActions(action: ColAction, row: unknown) {
    return;
  }

  colActionsTemplate(): TemplateRef<unknown> {
    return null;
  }
}
